import { ofType } from 'redux-observable';
import { ajax } from 'rxjs/ajax';
import { of } from 'rxjs';
import { map, switchMap, catchError } from 'rxjs/operators';
import { boundariesCriteria, organisationTabCriteria } from '../../../utilities/epic-helpers';

import {
  FETCH_BRAND_AFFINITY_SUBCATEGORIES_OPTIONS,
  FETCH_BRAND_AFFINITY_SUBCATEGORIES_OPTIONS_ERROR,
  SET_BRAND_AFFINITY_SUBCATEGORIES_OPTIONS
} from '../../constants';

const subcategoriesList = (action$, state$) =>
  action$.pipe(
    ofType(FETCH_BRAND_AFFINITY_SUBCATEGORIES_OPTIONS),
    switchMap(() =>
      ajax({
        url: `${state$.value.auth.server}/report/brand-affinity/top-pois/subcategories?${
          organisationTabCriteria(state$)
          }${
          boundariesCriteria(state$)
          }&v=${process.env.REACT_APP_VERSION}`,
        headers: {
          Authorization: state$.value.auth.token,
        },
        responseType: 'json',
        crossDomain: true,
      }).pipe(
        map(response => {
          return {
            type: SET_BRAND_AFFINITY_SUBCATEGORIES_OPTIONS,
            data: response.response,
          };
        }),
        catchError(error =>
          of({
            type: FETCH_BRAND_AFFINITY_SUBCATEGORIES_OPTIONS_ERROR,
            error,
          })
        )
      )
    )
  );

export default subcategoriesList;
